//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities } from '../Shared/Utility/Utilities';
import { MyTasksConfig } from '../MyTasks/MyTasksConfig';
import * as events from '../Shared/Bus/Bus';
import { ActivityListType, ActivityListFilter, ActivityListRequestModel } from '../Shared/Activity/Activity';
import { TaskFilter, TaskGroupFilter, TaskGroupOrder, TaskOrder } from '../Shared/Tasks/TaskModels';
import { ContactListConfig, ICAMSContact } from '../Shared/Contacts/ContactsModels';
import { Photos } from '../Shared/Photos/Photos';
import { IFilterDefinitionModel } from '../Shared/Models/FilteringModel';
import { CustomFiltersHelper } from '../Shared/Utility/CustomFiltersHelper';
import { CustomFilter } from '../Shared/Models/CustomFilterModels';
import { ReportModel, SystemType } from '../Reports/ReportsModels';
import { TaskManagement_EditTask } from './TaskManagement_EditTask';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';
import { Translations } from '../Shared/Models/StaticTranslations';

enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    CAMSMainPage_LeftPanels = '#CAMSMainPage_LeftPanels',
    CAMSMainPage_RightPanels = '#CAMSMainPage_RightPanels',
    CAMSMainToolbar_Container = '#CAMSMainToolbar_Container',

    tmRadio_UnassignedGroupTasks = '#tmRadio_UnassignedGroupTasks',
    tmRadio_AssignedGroupTasks = '#tmRadio_AssignedGroupTasks',
    tmRadio_CompletedGroupsAwaitingSignOff = '#tmRadio_CompletedGroupsAwaitingSignOff',
    tmRadio_RejectedGroupsTasks = '#tmRadio_RejectedGroupsTasks',
    tmRadio_CompletedGroupsAwaitingInspection = '#tmRadio_CompletedGroupsAwaitingInspection',
    tmRadio_PoolTasks = '#tmRadio_PoolTasks',
    taskManagementRecordListCloseBtn = '#taskManagementRecordListCloseBtn',
    taskManagementUserFilter = '#taskManagementUserFilter',
    taskManagementRecordFilter = '#taskManagementRecordFilter',
    taskManagementRecordListSelectAllBtn = '#taskManagementRecordListSelectAllBtn',
    taskManagementRecordListSearchBtn = '#taskManagementRecordListSearchBtn',
    taskManagementRecordListResultsCloseBtn = '#taskManagementRecordListResultsCloseBtn',
    taskManagementRecordListPrintBtn = '#taskManagementRecordListPrintBtn',
    taskManagementRecordListShowMapBtn = '#taskManagementRecordListShowMapBtn',
    taskManagementRecordListAssignBtn = '#taskManagementRecordListAssignBtn',
    taskManagementRecordListQueryBtn = '#taskManagementRecordListQueryBtn',
    taskManagementRecordListTaskEditContainer = '#taskManagementRecordListTaskEditContainer',
    taskManagementRecordListUnAssignBtn = '#taskManagementRecordListUnAssignBtn',
    taskManagementRecordListPoolAddBtn = '#taskManagementRecordListPoolAddBtn',
    taskManagementRecordListPoolRemoveBtn = '#taskManagementRecordListPoolRemoveBtn',
    taskManagementRecordListSignOffBtn = '#taskManagementRecordListSignOffBtn',
    taskManagementRecordListInspectBtn = '#taskManagementRecordListInspectBtn',
    taskManagementRecordListGroupTasksBtn = '#taskManagementRecordListGroupTasksBtn',
    taskManagementRecordListUnGroupTasksBtn = '#taskManagementRecordListUnGroupTasksBtn',
    taskManagementRecordListReGroupTasksBtn = '#taskManagementRecordListReGroupTasksBtn',
    taskManagementRecordListOtherStatusBtn = '#taskManagementRecordListOtherStatusBtn',
    taskManagementRecordListAnnotateBtn = '#taskManagementRecordListAnnotateBtn',
    taskManagementRecordListShowingStartBtn = '#taskManagementRecordListShowingStartBtn',
    taskManagementRecordListShowingEndBtn = '#taskManagementRecordListShowingEndBtn',
    taskManagementRecordListShowingNextBtn = '#taskManagementRecordListShowingNextBtn',
    taskManagementRecordListShowingPrevBtn = '#taskManagementRecordListShowingPrevBtn',
    taskManagementRecordListContainer = '#taskManagementRecordListContainer',
    taskManagementRecordListResultsContainer = '#taskManagementRecordListResultsContainer',
    taskManagementRecordListPanel = '#taskManagementRecordListPanel',
    taskManagementTaskEditCloseBtn = '#taskManagementTaskEditCloseBtn',
    taskManagementOpenParentFormBtn = '#taskManagementOpenParentFormBtn',
    taskManagementActivityBtn = '#taskManagementActivityBtn',
    taskManagementContactListBtn = '#taskManagementContactListBtn',
    RequiresInspection = '#RequiresInspection',
    taskManagementTaskEditInspectionContainer = '#taskManagementTaskEditInspectionContainer',
    taskManagementTaskEditReviewContainer = '#taskManagementTaskEditReviewContainer',
    taskManagementEditForm = '#taskManagementEditForm',
    taskManagementSubmitBtn = '#taskManagementSubmitBtn',
    taskManagementAssignBtn = '#taskManagementAssignBtn',
    taskManagementCancelBtn = '#taskManagementCancelBtn',
    taskManagementDeleteBtn = '#taskManagementDeleteBtn',
    taskManagementRecordListTreeResults = '#taskManagementRecordListTreeResults',
    taskManagementRecordListShowing ='#taskManagementRecordListShowing',
    taskManagementRecordListNumberCheckedBtn = '#taskManagementRecordListNumberCheckedBtn',
    taskManagementTaskGroupEditCloseBtn = '#taskManagementTaskGroupEditCloseBtn',
    taskGroupManagementActivityBtn = '#taskGroupManagementActivityBtn',
    taskGroupManagementContactListBtn = '#taskGroupManagementContactListBtn',
    taskGroupManagementEditForm = '#taskGroupManagementEditForm',
    taskGroupManagementSubmitBtn = '#taskGroupManagementSubmitBtn',
    taskGroupManagementCancelBtn = '#taskGroupManagementCancelBtn',
    taskGroupManagementEditView_ContactTypeLUTList = '#taskGroupManagementEditView_ContactTypeLUTList',
    taskGroupManagementEditView_contactSearch = '#taskGroupManagementEditView_contactSearch',
    taskGroupManagementEditView_assignToBtn = '#taskGroupManagementEditView_assignToBtn',

    tmRadio_UnassignedTasksCount = '#tmRadio_UnassignedTasksCount',
    tmRadio_UnassignedTasks = '#tmRadio_UnassignedTasks',
    taskManagementListPinBtn = '#taskManagementListPinBtn',
    taskManagementShowCustomFilterBtn = '#taskManagementShowCustomFilterBtn',
    taskManagementCustomFilterContainer = '#taskManagementCustomFilterContainer',

    taskManagementEditView_assignToField = '#taskManagementEditView_assignToField',
    taskGroupManagementEditView_assignToField = '#taskGroupManagementEditView_assignToField',
    taskGroupManagementTaskEditInspectionContainer = '#taskGroupManagementTaskEditInspectionContainer',
    taskGroupManagementTaskEditReviewContainer = '#taskGroupManagementTaskEditReviewContainer',

    taskManagementEditView_timeEst = '#taskManagementEditView_timeEst'
}

export class TaskManagementRecordList {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private treeView: any;
    private treeData: Array<INode> = [];
    private issueMaxNumberInList: number = 10;
    private issueCountFromServer: number = 0;
    private currentPage: number = 0;
    private taskStatusAwaitingInspection = "WI";
    private photos: Photos = new Photos();
    private pinListFormEl = Utilities.GetControl(jqc.taskManagementListPinBtn);
    private currentSortOrder;
    private currentSortDirection: OrderDirection;
    private customFilterHelper = new CustomFiltersHelper();
    private jobCustomFilterDefinitions: Array<CustomFilter> = [];
    private customFilterEl: JQuery<HTMLElement>;
    private taskManagement_EditTask = new TaskManagement_EditTask();

    // List of buttions in the action toolbar
    private actionBtns = {
        viewprint: { btn: $('#taskManagementRecordListPrintBtn button'), enable: false },
        showmap: { btn: $('#taskManagementRecordListShowMapBtn button'), enable: false },
        assign: { btn: $('#taskManagementRecordListAssignBtn button'), enable: false },
        //unassign: { btn: $('#taskManagementRecordListUnAssignBtn button'), enable: false },
        pooladd: { btn: $('#taskManagementRecordListPoolAddBtn button'), enable: false },
        //poolremove: { btn: $('#taskManagementRecordListPoolRemoveBtn button'), enable: false },
        signoff: { btn: $('#taskManagementRecordListSignOffBtn button'), enable: false },
        inspect: { btn: $('#taskManagementRecordListInspectBtn button'), enable: false },
        grouptasks: { btn: $('#taskManagementRecordListGroupTasksBtn button'), enable: false },
        ungrouptasks: { btn: $('#taskManagementRecordListUnGroupTasksBtn button'), enable: false },
        regrouptasks: { btn: $('#taskManagementRecordListReGroupTasksBtn button'), enable: false },
        annotate: { btn: $('#taskManagementRecordListAnnotateBtn button'), enable: false },
        other: { btn: $('#taskManagementRecordListOtherStatusBtn button'), enable: false },
        query: { btn: $('#taskManagementRecordListQueryBtn button'), enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // Show hide views depending on config
        if (MyTasksConfig.TaskGroupEnabled == false) {
            Utilities.GetControl(jqc.tmRadio_UnassignedGroupTasks).parent().hide();
            Utilities.GetControl(jqc.tmRadio_AssignedGroupTasks).parent().hide();
            Utilities.GetControl(jqc.tmRadio_CompletedGroupsAwaitingSignOff).parent().hide();
            Utilities.GetControl(jqc.tmRadio_RejectedGroupsTasks).parent().hide();
            Utilities.GetControl(jqc.tmRadio_CompletedGroupsAwaitingInspection).parent().hide();
        }

        if (MyTasksConfig.TaskPoolEnabled == false) {
            Utilities.GetControl(jqc.tmRadio_PoolTasks).parent().hide();
        }

        // Bind buttons
        Utilities.GetControl(jqc.taskManagementRecordListCloseBtn).on("click", function () {
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventResetAllButtons(true));
        });

        // Add pin btn event
        self.pinListFormEl.on("click", function () { Utilities.TogglePinListForm($(this)); });

        Utilities.GetControl(jqc.taskManagementUserFilter).on('change', function () { self.taskManagementUserFilterSelected(); });
        $('#taskManagementViewRadioGroup input').on('change', function () { self.taskManagementViewChanged(); });
        Utilities.GetControl(jqc.taskManagementRecordFilter).on('change', function () { self.recordFilterSelected(); });
        $('#taskManagementRecordListPageAmount select').on('change', function () { self.recordListPageAmountSelected(); });
        Utilities.GetControl(jqc.taskManagementRecordListSelectAllBtn).on('change', function () { self.recordListSelectAllChecked(); });
        Utilities.GetControl(jqc.taskManagementRecordListSearchBtn).on('click', function () {  self.GetTreeData(); this.blur(); });
        Utilities.GetControl(jqc.taskManagementRecordListResultsCloseBtn).on("click", function () { self.OpenRecordListPanel(); this.blur(); });

        // CUSTOM FILTER 
        // Get the custom filter definitions
        self.jobCustomFilterDefinitions = $(jqc.taskManagementRecordListResultsContainer + ' [data-jobcustomfilterdefinitions]').data('jobcustomfilterdefinitions');

        self.customFilterHelper = new CustomFiltersHelper();
        Utilities.GetControl(jqc.taskManagementShowCustomFilterBtn).on("click", function () {
            // Check if there are pcustom filters configured
            var i = self.getPredefinedFilterIndexOfCustomFilter();
            if (i == -1) {
                toastr.error("A pre-defined custom filter has been configured.");
                return;
            }

            Utilities.GetControl(jqc.taskManagementCustomFilterContainer).addClass('show');
            Utilities.GetControl(jqc.taskManagementShowCustomFilterBtn).addClass('text-success');
            self.customFilterHelper.customFilterAddRow(true);
            this.blur();
        });
        $(jqc.taskManagementCustomFilterContainer + ' [name="recordListCustomFilterAddBtn"]').on("click", function () {
            self.customFilterHelper.customFilterAddRow();
            this.blur();
        });

        // Get the initial custom filter element for later on
        self.customFilterEl = $(jqc.taskManagementCustomFilterContainer + ' [name="recordListCustomFilterRow"]').clone(false);
        $(jqc.taskManagementCustomFilterContainer + ' [name="recordListCustomFilterRow"]').remove(); // Then remove it, it is added by the ADD button later on

        Utilities.GetControl(jqc.taskManagementCustomFilterContainer + ' [name="recordListCustomFilterCloseBtn"]').on("click", function () {
            Utilities.GetControl(jqc.taskManagementCustomFilterContainer).removeClass('show');
            Utilities.GetControl(jqc.taskManagementShowCustomFilterBtn).removeClass('text-success');
            Utilities.GetControl(jqc.taskManagementRecordFilter).removeAttr("disabled");

            self.resetPage()
            Utilities.GetControl(jqc.taskManagementRecordFilter).prop("selectedIndex", 0);
            self.GetTreeData();
            this.blur();
        });
        Utilities.GetControl(jqc.taskManagementCustomFilterContainer + ' [name="recordListCustomFilterSearchBtn"]').on("click", function () {
            var i = self.getPredefinedFilterIndexOfCustomFilter();
            if (i == -1) {
                toastr.error("A pre-defined custom filter has been configured.");
                return;
            }

            // Disable the pre-defined filters and set to 'Custom Filter'
            Utilities.GetControl(jqc.taskManagementRecordFilter).prop("selectedIndex", i);
            Utilities.GetControl(jqc.taskManagementRecordFilter).attr("disabled", "disabled");

            self.GetTreeData();
            this.blur();
        });

        // Action buttons
        self.actionBtns.viewprint.btn.on('click', function () {
            // Setup variables
            let data: ReportModel = {};
            var values: Array<string> = [];
            let filterDef: IFilterDefinitionModel = Utilities.GetControl(jqc.taskManagementRecordFilter).children("option:selected").data('filterdefinition');

            // Get seleced nodes
            var nodes: Array<INode> = self.treeView.treeview('getSelected');
            if (nodes != null) {
                nodes = nodes.concat(self.treeView.treeview('getChecked')); // This makes sure we get all selected and checked nodes
                nodes.forEach(n => values.push(n.href));
            }

            // Get feature type
            if (nodes.length == 1) { data.systemType = SystemType.TaskManagement_Task_Single; }
            else { data.systemType = SystemType.TaskManagement_Task_Multi; }

            // If there is NO filterDef.viewName, then do not prompt the user 
            if (filterDef == null || filterDef.viewName == null) {
                var selectedMsg = "Selected Records Only (" + values.length + ")";
                data.reportParameters = [{ name: "codes", values: values }];
                events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
            }
            else {
                var filterMsg = "Filter (" + filterDef.label + ")";
                var selectedMsg = "Selected Records Only (" + values.length + ")";

                var dataStr = [{ key: "AllLabel", value: filterDef.label }, { key: "FilterLabel", value: values.length }, { key: "YesBtn", value: values.length }, { key: "NoBtn", value: filterDef.label }];
                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.RecordListReport, data: dataStr }).then(r => {
                    if (r.yes == true) {
                        data.reportParameters = [{ name: "codes", values: values }];
                        events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
                    }
                    else {
                        data.reportParameters = [{ name: "filterViewName", values: [filterDef.viewName] }];
                        events.bus.publish(events.eventOpenReportOrSelectList([data, filterMsg]));
                    }
                }).catch(e => { });

            }
        });

        Utilities.GetControl(jqc.taskManagementRecordListShowMapBtn).on("click", function () {
            self.ZoomToChecked(); this.blur(); });
        Utilities.GetControl(jqc.taskManagementRecordListAssignBtn).on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys.length == 0) return;
            events.bus.publish(events.eventOpenTasksAssignPanel([camsKeys, {submitResponse: true, showUnassignBtn: true}, null]));
            this.blur();
            
            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        });
        Utilities.GetControl(jqc.taskManagementRecordListPoolAddBtn).on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys.length == 0) return;
            events.bus.publish(events.eventOpenTasksPoolAddPanel(camsKeys));
            this.blur();
            
            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        });
        Utilities.GetControl(jqc.taskManagementRecordListSignOffBtn).on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys.length != 1) return;
            events.bus.publish(events.eventOpenTaskSignOffPanel(camsKeys[0])); this.blur();
            this.blur();

            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        });
        Utilities.GetControl(jqc.taskManagementRecordListInspectBtn).on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys.length != 1) return;
            events.bus.publish(events.eventOpenTaskInspectPanel(camsKeys[0])); this.blur();
            this.blur();
            
            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        });
        Utilities.GetControl(jqc.taskManagementRecordListGroupTasksBtn).on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys.length == 0) return;
            events.bus.publish(events.eventOpenTaskGroupTasksPanel(camsKeys));
            this.blur();
            
            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        });
        Utilities.GetControl(jqc.taskManagementRecordListUnGroupTasksBtn).on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys.length == 0) return;
            events.bus.publish(events.eventOpenTaskUnGroupTasksPanel(camsKeys));
            this.blur();
            
            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        });
        Utilities.GetControl(jqc.taskManagementRecordListReGroupTasksBtn).on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys.length == 0) return;
            events.bus.publish(events.eventOpenTaskReGroupTasksPanel(camsKeys)); this.blur();
            this.blur();
            
            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        });
        Utilities.GetControl(jqc.taskManagementRecordListOtherStatusBtn).on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys.length != 1) return;
            events.bus.publish(events.eventOpenOtherStatusTasksPanel(camsKeys[0])); this.blur();
            this.blur();

            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        });
        Utilities.GetControl(jqc.taskManagementRecordListAnnotateBtn).on("click", function () {
            let camsKeys = self.getCAMSKeyfromNodes();
            if (camsKeys.length == 0) return;
            events.bus.publish(events.eventShowAnnotationsForFeature([camsKeys[0], true]));
            this.blur();
        });

        Utilities.GetControl(jqc.taskManagementRecordListShowingStartBtn).on("click", function () {
            self.currentPage = 0;
            this.blur(); 
            self.GetTreeData();
        });
        Utilities.GetControl(jqc.taskManagementRecordListShowingEndBtn).on("click", function () {
            self.currentPage = Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList);
            this.blur(); 
            self.GetTreeData();
        });
        Utilities.GetControl(jqc.taskManagementRecordListShowingNextBtn).on("click", function () {
            if (self.currentPage == Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList)) return;

            self.currentPage++;
            this.blur(); 
            self.GetTreeData();
        });
        Utilities.GetControl(jqc.taskManagementRecordListShowingPrevBtn).on("click", function () {
            if (self.currentPage == 0) return;
            self.currentPage--;
            this.blur(); 
            self.GetTreeData();
        }); 
        Utilities.GetControl(jqc.taskManagementRecordListQueryBtn).on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getChecked');
            nodes = nodes.concat(self.treeView.treeview('getSelected'));
            let data: ICAMSKey = { code: nodes[0].href, featureType: nodes[0].featureType };
            events.bus.publish(events.eventOpenNotificationQueryPanel([data, null]));
            this.blur();
        });

    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public OpenRecordListPanel = (): void => {
        const self = this;

        // Get the page data on initial start up
        // Get the officer list, and if it is successful then get the data for the tree
        this.GetOfficerList(function () {
            // Set the default checked 
            $("#taskManagementViewRadioGroup input[type='radio']:checked").prop('checked', false);

            // Reset the page and focus the individual tasks btn
            self.resetPage();

            // Show the page
            Utilities.GetControl(jqc.taskManagementRecordListContainer).show();
            Utilities.GetControl(jqc.taskManagementRecordListResultsContainer).hide();
            Utilities.GetControl(jqc.taskManagementRecordListPanel).css('width', '300px');
            Utilities.GetControl(jqc.taskManagementRecordListPanel).addClass('show');

            // Get the count and initial tree when the panel is opened
            self.GetTaskCounts();
        });
    }

    private openTaskEditForm = (taskID: string): void => {
        const self = this;

        var showclass = "show600";
        var autoShowList = false;
        if (Utilities.IsListFormPinned(self.pinListFormEl) == false) {
            showclass = "show";
            autoShowList = true;
            Utilities.GetControl(jqc.taskManagementRecordListPanel).removeClass(showclass);
            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        }

        Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).addClass(showclass);
        Utilities.BlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));

        self.taskManagement_EditTask.openTaskEditForm(taskID, function (r) {
            if (r == false) {
                Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass(showclass);
                if (autoShowList == true) Utilities.GetControl(jqc.taskManagementRecordListPanel).addClass(showclass);
                self.treeView.treeview('unselectAll', { silent: true });
            }
            else {
                self.GetTreeData();
                self.GetTaskCounts();

                Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass(showclass);
                if (autoShowList == true) Utilities.GetControl(jqc.taskManagementRecordListPanel).addClass('show');
            }
        });
    }

    private openTaskGroupEditForm = (taskGroupID: number): void => {
        const self = this;

        var showclass = "show600";
        var autoShowList = false;
        if (Utilities.IsListFormPinned(self.pinListFormEl) == false) {
            showclass = "show";
            autoShowList = true;
            Utilities.GetControl(jqc.taskManagementRecordListPanel).removeClass(showclass);
            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        }

        Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).addClass(showclass);
        Utilities.BlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));
        Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).load(window.G_SITEFOLDERNAME +'/TaskManagement/TaskGroupEdit', { taskGroupID: taskGroupID }, function (response, status, xhr) {
            Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));

            //initialise photo uploader
            self.photos.setupUploader(jqc.taskManagementRecordListTaskEditContainer);

            // Set the assign to value
            var assignToTypeDescr_field = Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name="AssignToTypeDescr"]');
            var assignToListName_field = Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name="AssignToContactRefListName"]');
            if (assignToListName_field.val() != "") {
                Utilities.GetControl(jqc.taskGroupManagementEditView_assignToField).val(assignToListName_field.val());
            }
            else {
                Utilities.GetControl(jqc.taskGroupManagementEditView_assignToField).val(assignToTypeDescr_field.val());
            }
            // Contact Btn
            Utilities.GetControl(jqc.taskGroupManagementEditView_assignToBtn).on('click', function () {
                //TODO
            });

            // Show/hide the REVIEW panel
            Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresReview"]').on("change", function () {
                if (Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresReview"]').is(":checked") == true) {
                    Utilities.GetControl(jqc.taskGroupManagementTaskEditReviewContainer).show();
                }
                else {
                    Utilities.GetControl(jqc.taskGroupManagementTaskEditReviewContainer).hide();
                }
            });
            if (Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresReview"]').is(":checked") != true) { Utilities.GetControl(jqc.taskGroupManagementTaskEditReviewContainer).hide(); }

            // Show/hide the INSPECTION panel
            Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresInspection"]').on("change", function () {
                if (Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresInspection"]').is(":checked") == true) {
                    Utilities.GetControl(jqc.taskGroupManagementTaskEditInspectionContainer).show();
                }
                else {
                    Utilities.GetControl(jqc.taskGroupManagementTaskEditInspectionContainer).hide();
                }
            });
            if (Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name = "RequiresInspection"]').is(":checked") != true) { Utilities.GetControl(jqc.taskGroupManagementTaskEditInspectionContainer).hide(); }


            Utilities.GetControl(jqc.taskManagementTaskGroupEditCloseBtn).on('click', function () {
                Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass(showclass);
                if (autoShowList == true) Utilities.GetControl(jqc.taskManagementRecordListPanel).addClass('show');
                self.treeView.treeview('unselectAll', { silent: true });
            });

            Utilities.GetControl(jqc.taskGroupManagementActivityBtn).on("click", function () {
                const data: ICAMSKey = { code: taskGroupID.toString(), featureType: FeatureType.TaskGroup };
                self.showActivityInPopover(data, null);
                this.blur();
            });
            Utilities.GetControl(jqc.taskGroupManagementContactListBtn).on("click", function () {
                let assignedTo = Utilities.GetControl(jqc.taskGroupManagementEditForm+ ' [name="AssignToContactRef"]').val().toString();
                events.bus.publish(events.eventOpenAssignedTasksForm([assignedTo, function (contactRef, contactRefListName) {
                    Utilities.GetControl(jqc.taskGroupManagementEditForm + ' [name="AssignToContactRef"]').val(contactRef);
                    Utilities.GetControl(jqc.taskGroupManagementEditView_assignToField).val(contactRefListName);
                }]));
                this.blur();
            });

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.taskGroupManagementEditForm));

            Utilities.GetControl(jqc.taskGroupManagementSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.taskGroupManagementEditForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));
                let formData = new FormData(<any>Utilities.GetControl(jqc.taskGroupManagementEditForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: window.G_SITEFOLDERNAME + '/Tasks/UpdateTaskGroup',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated task group!');
                                self.GetTreeData();
                                self.GetTaskCounts();
                                
                                Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass(showclass);
                                if (autoShowList == true) Utilities.GetControl(jqc.taskManagementRecordListPanel).addClass('show');
                            }
                            else {
                                toastr.error('Failed to update task group');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.taskGroupManagementCancelBtn).on('click', function (evt) {
                Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass(showclass);
                if (autoShowList == true) Utilities.GetControl(jqc.taskManagementRecordListPanel).addClass('show');
            });

        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetTreeData = (): void => {
        const self = this;

        // Get the contact
        let contactRef = Utilities.GetControl(jqc.taskManagementUserFilter).children("option:selected").val();

        // Get the selected view
        let filter = $("#taskManagementViewRadioGroup input[type='radio']:checked").data("filter");
        let filters = [];
        let groupFilters = [];
        let url = "";
        if (filter == null || (filter.MyTasksFilter == undefined && filter.MyTaskGroupsFilter == undefined)) {
            return; // If the filter is not set, do not run the query
        }
        else if (filter.MyTasksFilter != undefined) {
            filters.push(filter.MyTasksFilter);
            url = window.G_SITEFOLDERNAME + "/TaskManagement/GetTaskManagementTreeData";
        }
        else {
            groupFilters.push(filter.MyTaskGroupsFilter);
            url = window.G_SITEFOLDERNAME + "/TaskManagement/GetTaskManagementGroupTreeData";
        }

        var viewName = "";
        let filterDef: IFilterDefinitionModel = Utilities.GetControl(jqc.taskManagementRecordFilter).children("option:selected").data('filterdefinition');
        if (filterDef != null) { viewName = filterDef.viewName; }

        var customFilters: Array<CustomFilter> = self.customFilterHelper.customFilterGetFilters();

        let query = {
            data: {
                ViewName: viewName,
                ContactRef: contactRef,
                Filters: filters,
                CustomFilters: customFilters,
                GroupFilters: groupFilters,
                Order: self.currentSortOrder,
                OrderDirection: self.currentSortDirection,
                Skip: self.currentPage * self.issueMaxNumberInList,
                Take: self.issueMaxNumberInList
            }
        };
        
        Utilities.BlockUI(Utilities.GetControl(jqc.taskManagementRecordListResultsContainer));
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        self.DeleteAllNodes();

                        // Create tree
                        var data = result.data.nodes as Array<INode>;
                        self.createTreeData(data);
                        self.createTree(self.treeData, true);

                        // Reset button
                        self.checkVisibleButtons();

                        // Update UI
                        self.updatePagingUI();
                       
                        // Update count
                        var countStr = "";
                        if (result && result.data && result.data.totalCount) {
                            countStr = " (" + result.data.totalCount + ")";
                            self.issueCountFromServer = result.data.totalCount;
                        }

                        $("#tmSelectedView_TitleCount").html(countStr);
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListResultsContainer));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetOfficerList = (callback): void => {
        const self = this;
        let url = window.G_SITEFOLDERNAME + "/Contacts/GetOfficers";
        let query = { data: { skip: 0, take: 0 } };
 
        $.post(url, query,
            function (response) {
                try {
                    // Populate the list based on the selected group name
                    // This will append all of the officers to the existing node (which is the current user)
                    Utilities.GetControl(jqc.taskManagementUserFilter + " option").remove().end();
                    var c = Utilities.GetControl(jqc.taskManagementUserFilter).data("contactref");
                    var d = Utilities.GetControl(jqc.taskManagementUserFilter).data("displayname");
                    Utilities.GetControl(jqc.taskManagementUserFilter).append($("<option></option>").attr("value", c).text(d));
                    Utilities.GetControl(jqc.taskManagementUserFilter).append($("<option></option>").attr("value", "").text("All"));

                    var result = JSON.parse(response);
                    result.forEach(i => {
                        Utilities.GetControl(jqc.taskManagementUserFilter).append($("<option></option>").attr("value", i.ContactRef).text(i.ListName));
                    });

                    callback();
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListContainer));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetTaskCounts = (): void => {
        const self = this;
        let url = "/TaskManagement/GetTaskManagementCount";
        let contactRef = Utilities.GetControl(jqc.taskManagementUserFilter).children("option:selected").val();
        let query = {
            contactRef: contactRef,
            Filters: [
                TaskFilter.All, TaskFilter.AdoptAPathTasks, TaskFilter.AssignedTasks, TaskFilter.OrphanTasks,
                TaskFilter.PoolTasks, TaskFilter.RejectedTasks, TaskFilter.UnassignedTasks, TaskFilter.CompletedTaskAwaitingInspection, TaskFilter.CompletedTasksAwaitingSignOff,
                TaskFilter.UnassignedRepeatTasks, TaskFilter.AssignedRepeatTasks
            ],
            GroupFilters: [
                TaskGroupFilter.All, TaskGroupFilter.AssignedGroupTasks, TaskGroupFilter.RejectedTaskGroups, TaskGroupFilter.UnassignedGroupTasks,
                TaskGroupFilter.CompletedTaskGroupsAwaitingInspection, TaskGroupFilter.CompletedTaskGroupsAwaitingSignOff
            ]
        };

        Utilities.BlockUI(Utilities.GetControl(jqc.taskManagementRecordListContainer));
        $.post(url, query, function (response: IAPIResult) {
            try {
                Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListContainer));
                if (response.data.filters != null) {
                    let filters = JSON.parse(response.data.filters);
                    Object.keys(filters).forEach(f => {
                        switch (TaskFilter[f]) {
                            case TaskFilter.UnassignedTasks:
                                Utilities.GetControl(jqc.tmRadio_UnassignedTasksCount).html(filters[f]);
                                setViewStyle(Utilities.GetControl(jqc.tmRadio_UnassignedTasks).parent(), filters[f]);
                                break;
                            case TaskFilter.AssignedTasks:
                                $('#tmRadio_AssignedTasksCount').html(filters[f]);
                                setViewStyle($('#tmRadio_AssignedTasks').parent(), filters[f]);
                                break;
                            case TaskFilter.CompletedTasksAwaitingSignOff:
                                $('#tmRadio_CompletedAwaitingSignOffCount').html(filters[f]);
                                setViewStyle($('#tmRadio_CompletedAwaitingSignOff').parent(), filters[f]);
                                break;
                            case TaskFilter.RejectedTasks:
                                $('#tmRadio_RejectedTasksCount').html(filters[f]);
                                setViewStyle($('#tmRadio_RejectedTasks').parent(), filters[f]);
                                break;
                            case TaskFilter.PoolTasks:
                                $('#tmRadio_PoolTasksCount').html(filters[f]);
                                setViewStyle(Utilities.GetControl(jqc.tmRadio_PoolTasks).parent(), filters[f]);
                                break;
                            case TaskFilter.CompletedTaskAwaitingInspection:
                                $('#tmRadio_CompletedAwaitingInspectionCount').html(filters[f]);
                                setViewStyle($('#tmRadio_CompletedAwaitingInspection').parent(), filters[f]);
                                break;
                            case TaskFilter.AdoptAPathTasks:
                                $('#tmRadio_AdoptAPathTasksCount').html(filters[f]);
                                setViewStyle($('#tmRadio_AdoptAPathTasks').parent(), filters[f]);
                                break;
                            case TaskFilter.OrphanTasks:
                                $('#tmRadio_OrphanTasksCount').html(filters[f]);
                                setViewStyle($('#tmRadio_OrphanTasks').parent(), filters[f]);
                                break;
                            case TaskFilter.All:
                                $('#tmRadio_AllTasksCount').html(filters[f]);
                                setViewStyle($('#tmRadio_AllTasks').parent(), filters[f]);
                                break;
                            case TaskFilter.UnassignedRepeatTasks:
                                $('#tmRadio_UnassignedRepeatTasksCount').html(filters[f]);
                                setViewStyle($('#tmRadio_UnassignedRepeatTasks').parent(), filters[f]);
                                break;
                            case TaskFilter.AssignedRepeatTasks:
                                $('#tmRadio_AssignedRepeatTasksCount').html(filters[f]);
                                setViewStyle($('#tmRadio_AssignedRepeatTasks').parent(), filters[f]);
                                break;
                        }
                    });
                }

                if (response.data.groupFilters != null) {
                    let gFilters = JSON.parse(response.data.groupFilters);
                    Object.keys(gFilters).forEach(f => {
                        switch (TaskGroupFilter[f]) {
                            case TaskGroupFilter.UnassignedGroupTasks:
                                $('#tmRadio_UnassignedGroupTasksCount').html(gFilters[f]);
                                setViewStyle(Utilities.GetControl(jqc.tmRadio_UnassignedGroupTasks).parent(), gFilters[f]);
                                break;
                            case TaskGroupFilter.AssignedGroupTasks:
                                $('#tmRadio_AssignedGroupTasksCount').html(gFilters[f]);
                                setViewStyle(Utilities.GetControl(jqc.tmRadio_AssignedGroupTasks).parent(), gFilters[f]);
                                break;
                            case TaskGroupFilter.CompletedTaskGroupsAwaitingSignOff:
                                $('#tmRadio_CompletedGroupsAwaitingSignOffCount').html(gFilters[f]);
                                setViewStyle(Utilities.GetControl(jqc.tmRadio_CompletedGroupsAwaitingSignOff).parent(), gFilters[f]);
                                break;
                            case TaskGroupFilter.RejectedTaskGroups:
                                $('#tmRadio_RejectedGroupsTasksCount').html(gFilters[f]);
                                setViewStyle(Utilities.GetControl(jqc.tmRadio_RejectedGroupsTasks).parent(), gFilters[f]);

                                break;
                            case TaskGroupFilter.CompletedTaskGroupsAwaitingInspection:
                                $('#tmRadio_CompletedGroupsAwaitingInspectionCount').html(gFilters[f]);
                                setViewStyle($('#tmRadio_CompletedGroupsAwaitingInspection').parent(), gFilters[f]);
                                break;
                            case TaskGroupFilter.All:
                                $('#tmRadio_AllTaskGroupsCount').html(gFilters[f]);
                                setViewStyle($('#tmRadio_AllTaskGroups').parent(), gFilters[f]);
                                break;
                        }
                    });
                }
            }
            catch (err) {
                console.log(err);
                alert(err);
            }
            finally {
                Utilities.UnBlockUI(Utilities.GetControl(jqc.taskManagementRecordListContainer));
            }
        });

        function setViewStyle(el, num: number) {
            if (num > 0) {
                el.css('font-weight', '600');
                el.css('color', 'black');
            }
            else {
                el.css('font-weight', '400');
                //el.css('color', '#6c757d');
            }
        }
    }

    // ----------------------------------------------------------- //
    // ON SELECT CHANGE
    private taskManagementViewChanged = (): void => {
        const self = this;
        this.resetPage();
      
        let filterStr: string = "";
        let selected = $("#taskManagementViewRadioGroup input[type='radio']:checked");
        if (selected.length > 0) {
            //let id = (selected[0] as any).id;
            //let label = ($("label[for='" + id + "']") as any)[0];
            //filterStr = label.textContent;
            filterStr = selected.parent().text();
            filterStr = filterStr.substring(0, filterStr.indexOf('('));
        }
        $("#tmSelectedView_Title").html(filterStr);
    
        // Show forms
        Utilities.GetControl(jqc.taskManagementRecordListPanel).removeClass('show');
        setTimeout(function () {
            Utilities.GetControl(jqc.taskManagementRecordListContainer).hide();
            Utilities.GetControl(jqc.taskManagementRecordListResultsContainer).show();
            Utilities.GetControl(jqc.taskManagementRecordListPanel).css('width', '600px');
            Utilities.GetControl(jqc.taskManagementRecordListPanel).addClass('show');
        }, 500);

        // Reset custom filters
        self.customFilterHelper.init(Utilities.GetControl(jqc.taskManagementCustomFilterContainer), self.customFilterEl, self.jobCustomFilterDefinitions);
        Utilities.GetControl(jqc.taskManagementCustomFilterContainer).removeClass('show');
        Utilities.GetControl(jqc.taskManagementShowCustomFilterBtn).removeClass('text-success');

        // Update the second filter
        this.checkFilters();

        // Get data for the tree
        this.GetTreeData();
    }
    
    private recordFilterSelected = (): void => {
        this.resetPage();
        this.GetTreeData();
    }

    private taskManagementUserFilterSelected = (): void => {
        this.resetPage();
        this.GetTreeData();
        this.GetTaskCounts();
    }

    private recordListPageAmountSelected = (): void => {
        this.issueMaxNumberInList = $('#taskManagementRecordListPageAmount select').children("option:selected").val() as number; 
        
        Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        this.GetTreeData();
    }

    private recordListSelectAllChecked = (): void => {
        const self = this;
        if (Utilities.GetControl(jqc.taskManagementRecordListSelectAllBtn).is(":checked") == true) {
            self.treeView.treeview('checkAll', { silent: true });
        }
        else {
            self.treeView.treeview('uncheckAll', { silent: true });
        }
        self.checkVisibleButtons();
    }

    public TaskUpdatedEvent = (camsKey: ICAMSKey): void => {
        // This fires when the task has been updated (e.g. accepted, etc). So refresh the tree
        this.GetTreeData();
        this.GetTaskCounts();
    }

    // ----------------------------------------------------------- //
    // CREATE/ADD TREE
    private createTree = (data: Array<INode>, colapseAll: boolean): void => {
        const self = this;

        var tree: any = Utilities.GetControl(jqc.taskManagementRecordListTreeResults);
        self.treeView = tree.treeview({
            data: data,
            showCheckbox: true,
            multiSelect: false,
            highlightSelected: true,
            onNodeSelected: function (event, node) {
                // Check if any TaskGroup nodes are selected. If they are de-select them and vice versa
                //self.treeView.treeview('getSelected').forEach(n => {
                //    if (node.featureType == FeatureType.TaskGroup && n.featureType != FeatureType.TaskGroup) {
                //        self.treeView.treeview('unselectNode', n, { silent: true });
                //    }
                //    else if (node.featureType != FeatureType.TaskGroup && n.featureType == FeatureType.TaskGroup) {
                //        self.treeView.treeview('unselectNode', n, { silent: true });
                //    }
                //});

                // Show the task if only one is selected
                self.showHideEditForm();
                self.treeView.treeview('uncheckAll', [{ silent: true }]);
                self.checkVisibleButtons(node);
                self.updateNumberCheckedMessage(); 
            },
            onNodeUnselected: function (event, node) {
                self.showHideEditForm();
                self.updateNumberCheckedMessage(); 
            },
            onNodeChecked: function (event, node) {
                //if (node.nodes != null) {
                //    let nodeIds = []; node.nodes.forEach(n => nodeIds.push(n.nodeId));
                //    self.treeView.treeview('checkNode', [nodeIds, { silent: false }]);
                //}
                //  Check button logic
                self.treeView.treeview('unselectAll', [{ silent: true }]);
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            },
            onNodeUnchecked: function (event, node) {
                //if (node.nodes != null) {
                //    let nodeIds = []; node.nodes.forEach(n => nodeIds.push(n.nodeId));
                //    self.treeView.treeview('uncheckNode', [nodeIds, { silent: false }]);
                //}
                //  Check button logic
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            },
            onMapBtnClicked: function (event, node) {
                if (node.wkt) {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[node.wkt], true, true, node.featyreType]));
                }
                else {
                    toastr.info('The record has no associated map feature')
                }
            }
        });

        // Create header
        self.createTreeHeader();

        if (colapseAll == true) {
            self.treeView.treeview('collapseAll');
        }

        self.updateNumberCheckedMessage();
    }

    private createTreeData = (input: Array<INode>): void => {
        const self = this;
        var inNode = input.find(f => f.featureType == FeatureType.TaskParent);
        if (inNode != null && inNode.nodes != null) {
            inNode.nodes.forEach(i => {
                self.treeData.push(i);
            });
        }

        count(FeatureType.TaskParent);

        function count(featureType: FeatureType) {
            let outNode = self.treeData.find(f => f.featureType == featureType);
            if (outNode != null) {
                if (outNode.nodes == null) {
                    outNode.count = 0;
                }
                else {
                    outNode.count = outNode.nodes.length;
                }
            }
        }
    }

    private DeleteAllNodes = (): void => {
        this.treeData = [];
        this.createTree(this.treeData, true);
    }

    private ZoomToChecked = (): void => {
        const self = this;
        var nodes: Array<INode> = self.treeView.treeview('getChecked');
        nodes.push(self.treeView.treeview('getSelected'));

        var wktArr = []; var hrefArr = []; var featureType;
        nodes.forEach(n => {
            // Check if this is a group node, if it is, add all the wKT's below it
            if (n.featureType == FeatureType.TaskGroup && n.nodes != null) {
                n.nodes.forEach(i => { if (i.wkt != null && hrefArr.find(i => i.href == n.href) == null) { wktArr.push(i.wkt); hrefArr.push(i.href); featureType = i.featureType; }});
            }
            // If this this is not a group node, then just add it as normal. Check first to see if it is already added though
            if (n.wkt != null && hrefArr.find(i => i.href == n.href) == null) { wktArr.push(n.wkt); hrefArr.push(n.href);  };
        });
        events.bus.publish(events.eventZoomToWKTandHighlight([wktArr, true, true, featureType]));
    }

    // ----------------------------------------------------------- //
    // TREE HEADERS
    private createTreeHeader = (): void => {
        const self = this;

        var lang = window.isSiteInWelsh() == true ? 1 : 0;
        let filter = $("#taskManagementViewRadioGroup input[type='radio']:checked").data("filter");

        // Add the header to issues only
        var colDef;
        if (filter.MyTasksFilter != undefined) {
            colDef = [
                //{ label: "ID", value: TaskOrder.ID, size: 1 },
                { label: Translations.Lang.Type[lang], value: TaskOrder.Type, size: 1 },
                { label: Translations.Lang.Created[lang], value: TaskOrder.CreateDate, size: 2 },
                { label: Translations.Lang.Target[lang], value: TaskOrder.TargetDate, size: 2 },
                { label: Translations.Lang.Priority[lang], value: TaskOrder.Priority, size: 2 },
                { label: Translations.Lang.Location[lang], value: null, size: 3 },
                { label: Translations.Lang.Status[lang], value: TaskOrder.Status, size: 2 }
            ];

        }
        else {
            colDef = [
                { label: Translations.Lang.ID[lang], value: TaskGroupOrder.ID, size: 2 },
                { label: Translations.Lang.Priority[lang], value: TaskGroupOrder.Priority, size: 2 },
                { label: Translations.Lang.Type[lang], value: TaskGroupOrder.Type, size: 4 },
                { label: Translations.Lang.Status[lang], value: TaskGroupOrder.Status, size: 4 }
            ];
        }

        // Create the header
        self.treeView.treeview('addHeader', {
            cols: colDef,
            currentSortDirection: self.currentSortDirection,
            currentSortOrder: self.currentSortOrder,
            callback: function (order, dir) {
                self.currentSortOrder = order;
                self.currentSortDirection = dir;
                self.GetTreeData();
            }
        });

    }

    private checkVisibleButtons = (selectedNode: INode = null): void => {
        const self = this;
        let nodes: INode[] = self.treeView.treeview('getChecked');
        if (selectedNode != null && nodes.length == 0) nodes.push(selectedNode); // Add the selected node to the list if it is not null

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => { self.actionBtns[k].enable = false; });

        var currentStatus: string;
        nodes.forEach(n => {
            // If status is null, then set it to unassigned
            if (n.data.Status == null || n.data.Status == "" || n.data.Status == undefined) n.data.Status = "UN";

            // If curretnStatus==null this is the first element, then just copy status to currentStatus
            if (currentStatus == null) currentStatus = n.data.Status;
            else {
                if (currentStatus != n.data.Status) currentStatus = "mixed";
            }
        });

        // Then switch on the ones we want depending on the node amount
        if (nodes && nodes.length > 0) {
            self.actionBtns.viewprint.enable = true;
            self.actionBtns.showmap.enable = true;
            self.actionBtns.query.enable = true;

            // If no task groups are selected, then switch off the buttons
            if (nodes.findIndex(n => n.featureType == FeatureType.TaskGroup) == -1) {
                self.actionBtns.grouptasks.enable = true;
                self.actionBtns.ungrouptasks.enable = true;
                self.actionBtns.regrouptasks.enable = true;
            }

            if (nodes.length == 1) {
                self.actionBtns.annotate.enable = true;
            }
        
            // Now check if the node status
            //self.actionBtns.assign.enable = true;
            //self.actionBtns.pooladd.enable = true;
            //self.actionBtns.signoff.enable = true;
            //self.actionBtns.inspect.enable = true;
            //self.actionBtns.other.enable = true;
            if (currentStatus == "UN" || currentStatus == "UR" || currentStatus == undefined || currentStatus == "" || currentStatus == null) {
                self.actionBtns.assign.enable = true;
                self.actionBtns.pooladd.enable = true;

                if (nodes.length == 1) {
                    self.actionBtns.signoff.enable = true;
                    self.actionBtns.other.enable = true;
                }
            }
            else if (currentStatus == "AP") {
                self.actionBtns.pooladd.enable = true;

                if (nodes.length == 1) {
                    self.actionBtns.signoff.enable = true;
                    self.actionBtns.other.enable = true;
                }
            }
            else if (currentStatus == "AU") {
                self.actionBtns.assign.enable = true;

                if (nodes.length == 1) {
                    self.actionBtns.signoff.enable = true;
                    self.actionBtns.other.enable = true;
                }
            }
            else if (currentStatus == "WR") {
                if (nodes.length == 1) {
                    self.actionBtns.other.enable = true;
                    self.actionBtns.signoff.enable = true;
                }
            }
            else if (currentStatus == "WI") {
                if (nodes.length == 1) {
                    self.actionBtns.inspect.enable = true;
                    self.actionBtns.other.enable = true;
                }
            }
            else if (currentStatus == "COM") {
                if (nodes.length == 1) {
                    self.actionBtns.other.enable = true;
                }
            }
            else {
                self.actionBtns.assign.enable = true;
                if (nodes.length == 1) {
                    self.actionBtns.inspect.enable = true;
                    self.actionBtns.pooladd.enable = true;
                    self.actionBtns.other.enable = true;
                    self.actionBtns.signoff.enable = true;
                }
            }
        }

        // Quick check, if no TaskGroups are present in the tree, then always disable these buttons
        var checkedNodes: INode[] = self.treeView.treeview('getChecked');
        var uncheckedNodes: INode[] = self.treeView.treeview('getUnchecked');
        if (checkedNodes.find(c => c.featureType == FeatureType.TaskGroup) == null && uncheckedNodes.find(c => c.featureType == FeatureType.TaskGroup) == null) {
            self.actionBtns.ungrouptasks.btn.parent().hide();
            self.actionBtns.regrouptasks.btn.parent().hide();
        }
        else {
            self.actionBtns.ungrouptasks.btn.parent().show();
            self.actionBtns.regrouptasks.btn.parent().show();
        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    private showHideEditForm = (): void => {
        const self = this;
        // Show the task if only one is selected
        if (self.treeView.treeview('getSelected') && self.treeView.treeview('getSelected').length == 1) {
            let n: INode = self.treeView.treeview('getSelected')[0];
            if (n.featureType == FeatureType.Task) {
                self.openTaskEditForm(n.href);
            }
            else {
                self.openTaskGroupEditForm(parseInt(n.href));
            }
        }
        else {
            Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        }
    }

    private updateNumberCheckedMessage = (): void => {
        let num = this.treeView.treeview('getChecked').length;
        let s = num > 1 ? "s" : "";
        if (num == 0) {
            Utilities.GetControl(jqc.taskManagementRecordListNumberCheckedBtn).hide();
        }
        else {
            Utilities.GetControl(jqc.taskManagementRecordListNumberCheckedBtn).html(`${num} item${s} selected`);
            Utilities.GetControl(jqc.taskManagementRecordListNumberCheckedBtn).show();
        }
    }
   
    // ----------------------------------------------------------- //
    // MISC
    private updatePagingUI = (): void => {
        const self = this;
        if (self.issueCountFromServer > 0) { $('#recordCount').html(' (' + self.issueCountFromServer + ')'); } else { $('#recordCountIndividual').html(); }
        Utilities.GetControl(jqc.taskManagementRecordListShowing).html((self.currentPage + 1).toString());
    }

    private resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.issueCountFromServer = 0;
        
        Utilities.GetControl(jqc.taskManagementRecordListTaskEditContainer).removeClass('show600');
        $('#taskManagementViewRadioGroup label').removeClass('active');
        $(jqc.taskManagementCustomFilterContainer + ' [name="recordListCustomFilterRow"]').remove();
        var tree: any = Utilities.GetControl(jqc.taskManagementRecordListTreeResults);
        this.treeData = [];
        this.treeView = tree.treeview();
        this.updatePagingUI();
    }

    private checkFilters = (): void => {
        Utilities.GetControl(jqc.taskManagementRecordFilter).find('option').remove().end();

        let filter = $("#taskManagementViewRadioGroup input[type='radio']:checked").data("filter");
        if (filter.MyTasksFilter != undefined) {
            let filters: Array<IFilterDefinitionModel> = $(jqc.taskManagementRecordListResultsContainer + ' [data-mytaskslistfilters]').data('mytaskslistfilters');
            filters.forEach(f => {
                Utilities.GetControl(jqc.taskManagementRecordFilter).append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
            });

        }
        else {
            let filters: Array<IFilterDefinitionModel> = $(jqc.taskManagementRecordListResultsContainer + ' [data-mytaskgroupslistfilters]').data('mytaskgroupslistfilters');
            filters.forEach(f => {
                Utilities.GetControl(jqc.taskManagementRecordFilter).append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
            });

        }

        function isNumber(value: string | number): boolean {
            return ((value != null) &&
                (value !== '') &&
                !isNaN(Number(value.toString())));
        }
    }

    private showActivityInPopover = (data: ICAMSKey, parentModal: JQuery<HTMLElement>): void => {
        let model: ActivityListRequestModel = { ID: data.code, ActivityListType: ActivityListType.TaskActivity, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
        events.bus.publish(events.eventShowActivityList([Utilities.GetControl(jqc.taskManagementActivityBtn), model, parentModal]));
    }

    private getCAMSKeyfromNodes = (): Array<ICAMSKey> => {
        let camsKeys: Array<ICAMSKey> = [];
        let nodes: Array<INode> = this.treeView.treeview('getChecked');
        nodes  = nodes.concat(this.treeView.treeview('getSelected'));
        if (nodes && nodes.length) {
            nodes.forEach(n => {
                if (camsKeys.find(c => c.code == n.href) == null) {
                    let camsKey: ICAMSKey = { code: n.href, featureType: n.featureType, wkt: n.wkt, parentCode: n.parentCode, parentFeatureType: n.parentFeatureType };
                    camsKeys.push(camsKey);
                }
            });
        }

        return camsKeys;
    }

    private getPredefinedFilterIndexOfCustomFilter = (): number => {
        var i = -1; var counter = 0;

        Utilities.GetControl(jqc.taskManagementRecordFilter + " option").each(function () {
            var data: IFilterDefinitionModel = $(this).data('filterdefinition');
            if (data && data.customFilter && data.customFilter == true) {
                i = counter;
            }
            counter++;
        });
        return i;
    }
}




